import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader } from '@/components/ui'

interface AuthLayoutProps {
  title: string
  subtitle: string
  children: React.ReactNode
  footer: {
    text: string
    linkText: string
    linkTo: string
  }
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-muted/50 to-primary/10 p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <Card className="shadow-warm-lg">
          <CardHeader className="space-y-2 text-center">
            <Link to="/dashboard" className="mb-2 flex justify-center">
              <img src="/logo.png" alt="Logo" className="h-10" />
            </Link>
            <div className="space-y-1">
              <h2 className="text-xl font-semibold">{title}</h2>
              <p className="text-sm text-muted-foreground">{subtitle}</p>
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            {children}
            <div className="text-center text-sm text-muted-foreground">
              {footer.text}{' '}
              <Link to={footer.linkTo} className="font-medium text-primary hover:underline">
                {footer.linkText}
              </Link>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  )
}
